import { render, staticRenderFns } from "./activityRule.vue?vue&type=template&id=51934b5d&scoped=true"
import script from "./activityRule.vue?vue&type=script&lang=js"
export * from "./activityRule.vue?vue&type=script&lang=js"
import style0 from "./activityRule.vue?vue&type=style&index=0&id=51934b5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51934b5d",
  null
  
)

export default component.exports